export default __webpack_public_path__ + "static/media/gg7.30bced75.jpeg";